export const openIntercomHelp = () => {
    window.open('https://help.mybodygraph.com/', '_blank');
}